import { useAutoOpenWhatsNew } from './hooks/useAutoOpenWhatsNew.hook';

/**
 * Renders nothing — it exists only to host the auto-open data subscriptions.
 *
 * SellerPageTemplate defines its child components (MainContent, NavigationBar)
 * inline, so any re-render of the template gives them fresh identities and
 * remounts the whole page. Running the auto-open hook (which subscribes to the
 * What's New + shared-functionality queries) directly in the template would
 * therefore remount the current page — flicker and lost state — every time
 * those background queries resolve. Isolating the hook here confines that
 * re-render to this component, which returns null.
 */
export const AutoOpenWhatsNew = ({
  setIsOpen,
}: {
  setIsOpen: (isOpen: boolean) => void;
}) => {
  useAutoOpenWhatsNew(setIsOpen);
  return null;
};
